export class ComponentItem {
    constructor (
        public id: number,
        public name: string,
        public shortName: string,
        public routeName: string,
        public icon: string,
        public color: string,
        public selected: boolean,
        public active: boolean,
        public display: boolean,
        public description: string,
        public availableAdmin: boolean,
        public availableStdUser: boolean,
        public availableReadUser: boolean

        ) { }    
}